// Every action item change the socket delivers, before App filters out this tab's own
// requests or drops the ones whose mission is not in app.state.missions. Screens that
// keep their own task list (Home) listen here instead of waiting on missionChange,
// which only fires for loaded missions.

const listeners = new Set()

export function emitActionItemChanges(operation, changes) {
    if (!Array.isArray(changes) || !changes.length) return

    listeners.forEach((cb) => {
        try {
            cb(operation, changes)
        } catch (e) {
            console.error(e)
        }
    })
}

export function onActionItemChanges(cb) {
    listeners.add(cb)

    return () => listeners.delete(cb)
}

// A deleted mission archives its tasks on the API, which sends a socket message for the
// mission only: no task delete ever arrives for them.
const missionDeletedListeners = new Set()

export function emitMissionDeleted(missionId) {
    if (!missionId) return

    missionDeletedListeners.forEach((cb) => {
        try {
            cb(missionId)
        } catch (e) {
            console.error(e)
        }
    })
}

export function onMissionDeleted(cb) {
    missionDeletedListeners.add(cb)

    return () => missionDeletedListeners.delete(cb)
}
